import { Switch } from "@headlessui/react";
import { classNames } from "../../utils/helpers";

/**
 * ActiveToggle — Reusable teal Active/Inactive switch (SPR-007 FE-1).
 *
 * ON  = teal background (entity is Active, DeactivatedAt == null).
 * OFF = neutral aluminum background (entity is Inactive).
 *
 * Matches the Menu Management toggle look but uses brand teal explicitly
 * (the old shared ToggleInput referenced a non-existent `bg-primaryColor`).
 *
 * @param {object}   props
 * @param {boolean}  props.enabled    - true when the entity is Active.
 * @param {Function} props.onToggle   - Called when the switch is flipped.
 * @param {boolean} [props.disabled]  - When true the switch is non-interactive
 *                                       (e.g. a protected user — SPR-007 FE-6).
 * @param {string}  [props.label]     - Accessible label / aria-label.
 * @param {string}  [props.testId]    - data-testid for the switch.
 */
export default function ActiveToggle({
  enabled,
  onToggle,
  disabled = false,
  label = "Active",
  testId,
}) {
  return (
    <Switch
      checked={!!enabled}
      onChange={() => {
        if (!disabled) onToggle();
      }}
      disabled={disabled}
      aria-label={label}
      data-testid={testId}
      className={classNames(
        enabled ? "bg-teal" : "bg-aluminum",
        disabled ? "opacity-40 cursor-not-allowed" : "cursor-pointer",
        "relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-teal/40"
      )}
    >
      <span
        className={classNames(
          enabled ? "translate-x-6" : "translate-x-1",
          "inline-block h-4 w-4 transform rounded-full bg-white transition-transform"
        )}
      />
    </Switch>
  );
}
